import { IVo } from '@wizeoo/akm-compute-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { EntityModificationPack } from '@wizeoo/akm-message-lib';
import { ExternalAPI } from '../../model/external-api';
import { Model } from '../../model/model';
import { EmVO } from '../../vo/em/em.vo';
import { FeiVO } from '../../vo/workingdata/fei.vo';

/**
 * Appels du service de commit
 * Author LMA
 */
export class CommitCmd extends WizCommand<EntityModificationPack> {
  
  public model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }

  public sourcePack: EntityModificationPack = null; // les packs transmis au service

  public sourceVO: IVo[]; // les VOs sources
  public viewCallBack: Function = null; // la callback appelée en fin de traitement (par la callback) pour retour à la vue

  public rollbackElement: EmVO[] = null; // l'em de rollback
  public isRollback: boolean = false; // appel en mode rollback (pas de génération d'EM au retour)

  public fei: FeiVO = null; // source de donnée parente de l'objet modifié, pour refresh (le feiVO)
  public reference: any; // objet de référence pour modification par la callback
 
  /** update */
  public commit(
    pack: EntityModificationPack,
    callback: Function,
    sourceVO: IVo[] = null,
    viewCallBack: Function = null
  ): CommitCmd {
    // On s'assure de bien passer les données "globales" (BU, domain)
    this.sourcePack = {
      ...pack,
      businessUnitCode: this.model.businessUnitCode,
      domain: this.model.domainCode,
    };


    this.sourceVO = sourceVO;
    this.viewCallBack = viewCallBack;
    this.configureRemote(ExternalAPI.COMMIT_API, this.sourcePack, callback);
    return this;
  }

  /** Execution call
   * @override pour persistence locale des EMs (pour replay sur échec)
   */
  public async execute(): Promise<any> {
    super.execute();
  }

  /**
   * utilisation du lock, ou pas (pas de lock si silent = true)
   * Attention, écrasé par commit (qui fait un configure), donc l'appeler APRES
   */
  public silent(silent: boolean = true): CommitCmd {
    this.doLock = !silent;
    return this;
  }

  /**
   * activation du mode rollback
   */
  public rollback(rollbackElement: EmVO[] = null): CommitCmd {
    this.rollbackElement = rollbackElement;
    this.isRollback = rollbackElement !== null;
    return this;
  }

  /**
   * objet métier / collection cible contenant l'objet en cours de modification
   */
  public setDataset(fei: FeiVO): CommitCmd {
    this.fei = fei;
    return this;
  }

  /**
   * objet métier de référence pour callback
   */
  public setReference(reference: any): CommitCmd {
    this.reference = reference;
    return this;
  }

  /** sur retour, traitement selon la méthode */
  public wizResult() {
    this.sourcePack = this.result;
    super.wizResult();
  }

}
